import ko from 'knockout';

export default function (artist) {
  const self = this;

  this.artist_name = ko.observable(artist.name || '');
  this.slug = ko.observable(artist.slug || '');
  this.isActive = ko.observable(artist.isActive);
  this.isProcessingRequest = ko.observable(false);
  this.hasCompletedProfile = ko.observable(artist.hasCompletedProfile);
  this.isAdmin = ko.observable(artist.isAdmin);

  this.artist_name.subscribe((newValue) => {
    if (newValue.replace(/\s/g, '') !== '') {
      self.suggestUserName();
    } else {
      self.artist_name('');
    }
  });

  this.enableSlug = ko.computed(
    () => this.isAdmin() || !this.hasCompletedProfile(),
    this,
  );

  this.apply = () => {
    ko.applyBindings(this);
  };

  this.suggestUsernamePath = () => document.querySelector("meta[name='suggest-slug-path']").getAttribute('content');

  this.suggestUserName = () => {
    if (!this.isActive() && !this.hasCompletedProfile()) {
      const lookupPath = this.suggestUsernamePath();
      this.isProcessingRequest(true);

      const url = lookupPath + '?artist_name=' + this.artist_name()

      fetch(url)
        .then(response => response.json())
        .then(function(response) {
          const artistName = response.artist_name;
          const slugSuggested = response.slug_suggested

          if (artistName === self.artist_name()) {
            self.slug(slugSuggested);
          }
          self.isProcessingRequest(false);
        })
    }
  }
};
